import { render, staticRenderFns } from "./SocialEvent.vue?vue&type=template&id=b5255656&scoped=true&"
import script from "./SocialEvent.vue?vue&type=script&lang=ts&"
export * from "./SocialEvent.vue?vue&type=script&lang=ts&"
import style0 from "./SocialEvent.vue?vue&type=style&index=0&id=b5255656&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5255656",
  null
  
)

export default component.exports